import React from 'react';
import { ToastMessage } from '../ToastMessage';
import classnames from 'classnames';

import './PoorNetToastMessage.scss';


export default function PoorNetToastMessage (props) {
  const {className, ...otherProps} = props;

  return (
    <ToastMessage
      {...otherProps}
      className={classnames(className, 'poor-net-toast-message')}
    />
  );
}
